import React from 'react'
import { Button, Glyphicon } from 'react-bootstrap'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  from { transform: scale(1) rotate(0deg); }
  to { transform: scale(1) rotate(360deg); }
`
const StyledButton = styled(Button)`
  .spinning.glyphicon {
    margin-right: 7px;
    top: 2px;
    animation: ${spin} 1s infinite linear;
  }
`

const LoaBut = ({
  isLoading,
  text,
  loadingText,
  className = "",
  disabled = false,
  ...props
}) =>
  <StyledButton
    className={className}
    disabled={disabled || isLoading}
    {...props}
  >
    {isLoading && <Glyphicon glyph="refresh" className="spinning" />}
    {!isLoading ? text : loadingText}
  </StyledButton>

export default LoaBut